<div class="sidebar menu-min" id="sidebar" style="z-index: 101;" [class.display]="mobileExpanded" [class.collapsed]="isNavigationBarCollapsed">
  <div class="sidebar-shortcuts" id="sidebar-shortcuts" style="z-index: 1;">
    <div class="sidebar-shortcuts-large" id="sidebar-shortcuts-large" style="z-index: 1;">
      <button class="btn btn-cloud" title="{{localization.menuLabel | phxTranslate}}" (click)="selectedSideView = MENU">
        <i class="material-icons md-24">view_list</i>
      </button>
      <button class="btn btn-cloud" title="To Do List" (click)="selectedSideView = TODO" *ngIf="isTodoListEnabled">
        <i class="material-icons md-24 ">done_outline</i>
      </button>
      <button class="btn btn-cloud" title="{{localization.addToFavoritesLabel | phxTranslate}}"
        (click)="selectedSideView === ADD ? selectedSideView = ADDA : selectedSideView = ADD">
        <i class="material-icons md-24 shortcut-add-bookmark">star_border</i>
      </button>
    </div>
  </div>

  <!-- ngClass binding so the menu position is saved when going between bookmarks and menu -->
  <div class="new-div" [ngClass]="{'sidenav-hidden': (selectedSideView === MENU || selectedSideView === TODO)}">
    <app-bookmark-side-menu [eventName]="selectedSideView"></app-bookmark-side-menu>
  </div>

  <accordion *ngIf="navigation" closeOthers="true" [ngClass]="{'sidenav-hidden': selectedSideView !== MENU}">
    <div *ngFor="let n of navigation.NavigationItems">

      <!--no child-->
      <a *ngIf='!n.HasChildren && n.Code!=="dashboard"' [routerLink]="n.State" (click)="onSideNavLinkClick(n.Id)">
        <accordion-group class="parentPanel">
          <span accordion-heading>
            <i class='material-icons accordion-heading'>{{n.Icon}}</i>
            {{n.Value}}
          </span>
        </accordion-group>
      </a>

      <!--yes child-->
      <accordion-group *ngIf='n.HasChildren' [isOpen]="n.IsOpen" (isOpenChange)="accordionGroupOpenChange($event, n)">

        <span accordion-heading>
          <i class='material-icons accordion-heading'>{{n.Icon}}</i>
          {{n.Value}}
        </span>

        <div *ngFor='let s of n.Children' class="childPanel">
          <!--no child-->
          <a *ngIf='!s.HasChildren' [routerLink]="s.State" class="myButton" routerLinkActive="active-link"
            (click)="onSideNavLinkClick(s.Id)">
            <i *ngIf="s.Icon" class='material-icons'>{{s.Icon}}</i> {{s.Value}}
          </a>

          <!--yes child-->
          <ng-container *ngIf="s.HasChildren">
            <a (click)="toggleCollapsed(s)" class="myButton" routerLinkActive="active-link">
              {{s.Value}}
              <i class="arrow material-icons md-18" [ngClass]="{'arrowExpanded' : s.IsOpen}"></i>

            </a>
            <div [class.hide]="!s.IsOpen">
              <div *ngFor='let p of s.Children'>
                <a [routerLink]="p.State" class="myButtonSub" (click)="onSideNavLinkClick(p.Id)"
                  routerLinkActive="active-link">
                  {{p.Value}}
                </a>
              </div>
            </div>
          </ng-container>

        </div>
      </accordion-group>
    </div>
  </accordion>
  <app-todo-list [ngClass]="{'sidenav-hidden': selectedSideView !== TODO}"></app-todo-list>


</div>
<div
        class="sidebar-toggle"
        [class.collapsed]="isNavigationBarCollapsed"
        (click)="toggleNavigationBar()"
        [id]="'collapse-navigation-button-' + (isNavigationBarCollapsed ? 'open' : 'close' )"
>
    <mat-icon>
        {{ isNavigationBarCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}
    </mat-icon>
</div>
<div *ngIf="buildNumber" class="build-number" [class.collapsed]="isNavigationBarCollapsed">
    {{ buildNumber }}
</div>
